import React from 'react';
import './Services.css';

function Services() {
  const services = [
    {
      title: 'Same-day Courier',
      description: 'Fast and reliable same-day delivery services within Singapore and surrounding areas.',
      icon: '🚚'
    },
    {
      title: 'Express Delivery',
      description: 'Time-critical express delivery solutions for urgent shipments and packages.',
      icon: '⚡'
    },
    {
      title: 'Cargo Shipping',
      description: 'Comprehensive cargo shipping services for large shipments and freight.',
      icon: '📦'
    },
    {
      title: 'Import & Export',
      description: 'Full-service import and export solutions with customs clearance and documentation.',
      icon: '🌍'
    },
    {
      title: 'Document Handling',
      description: 'Secure and confidential document delivery services with tracking capabilities.',
      icon: '📄'
    }
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <h2 className="fade-in">Our Services</h2>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className={`service-card fade-in fade-in-delay-${index + 1}`}>
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;